const Api = {
    ACT_TOKEN : "/api/actran/token",
    ACT_GET_SALE_EMPLOYEE : "/api/actran/sale/mployee/find-by-code",
    ACT_SALE_EMPLOYEE : "/api/actran/sale/employee",

    AUTH_LOGIN: "/user/login",
    AUTH_CHANGE_PASSWORD: "/user/change/password",

    ORDER_STATE_LIST: "/order/state/list",

    UPDATE_PENDING: "/order/state/update-pending"

};
export default Api;